module.exports = __webpack_public_path__ + "static/Burst_1-a6f447aa8671ee13ee50010c71fb35fb.jpg";